import { useEffect } from 'react';
import useAsyncInterval from 'Hooks/useAsyncInterval';
import { ACH_RELATIONSHIP_STATUSES } from 'Consts/managedAccountFunding';

const MAX_RETRIES = 10;
const RETRY_DELAY_IN_SECONDS = 2;


export default function useApexFundingAccountSync(resource, callback, onNext) {
  const isSyncRequired = resource.attr('status') === ACH_RELATIONSHIP_STATUSES.PENDING || resource.attr('status') === ACH_RELATIONSHIP_STATUSES.PENDING_ID_VERIFICATION_RESULTS;
  const syncStatus = () => isSyncRequired && callback();

  function handleNext() {
    if (onNext) onNext();
  }

  const interval = useAsyncInterval(syncStatus, {
    delay: RETRY_DELAY_IN_SECONDS,
    maxRetries: MAX_RETRIES,
    maxRetriesCallback: handleNext,
  });

  useEffect(() => {
    if (isSyncRequired) {
      interval.current.start();
    } else {
      interval.current.stop();
      handleNext();
    }

    return () => {
      interval.current.stop();
    };
  }, [isSyncRequired]);
}
